export default {
  SEARCH_BOX_PLACEHOLDER: 'Search for products',

  PRODUCT_REPEATER_CLASS: 'grid product-grid grid-2-col grid-3-col-tablet grid-compact grid-5-col-desktop',

  START_OVER: 'Clear filters',
  CHANGE_VEHICLE: 'Change Ride',
};
